// src/components/HeaderTransparent.jsx
import React from "react";
import { Link } from "react-router-dom";
import { usePublicLang } from "../../../config/i18n/public";

export default function HeaderTransparent() {
  const { copy } = usePublicLang();
  return (
<header className="fixed inset-x-0 top-0 z-50 hidden bg-black/50 backdrop-blur-md sm:block">
      <div className="mx-auto flex w-full max-w-[1480px] items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        {/* Logo left */}
        <Link to="/" className="flex items-center gap-2">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-white overflow-hidden shadow-sm">
            <img
              src="/steffi/logo.png"
              alt="Logo"
              className="h-10 w-10 object-contain"
            />
          </div>
          <span className="ml-1 text-xl font-bold tracking-wide text-[#ffffff]">
            SteffiCare
          </span>
        </Link>

        <div className="flex items-center gap-2">
          <Link
            to="/angehoerige"
            className="rounded-full border border-[#e8ddd3] bg-[#fcf7f3] px-4 py-2 text-xs font-semibold text-[#24211e] shadow-md transition hover:bg-[#f8f2ec] sm:px-5 sm:text-sm"
          >
            {copy.landing.for_family}
          </Link>
          <Link
            to="/termin"
            className="hidden max-w-[168px] rounded-full bg-[#4285F4] px-4 py-2 text-xs font-medium leading-tight text-white shadow-md transition hover:bg-[#357ae8] sm:inline-flex sm:max-w-none sm:px-5 sm:text-sm"
          >
            {copy.header.cta}
          </Link>
        </div>
      </div>
    </header>
  );
}
